export default __webpack_public_path__ + "static/media/select.2b6e86b7.png";